import React from "react";
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Row, Col, Container } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
//import "../components/Menu.css";
import VN from "../components/VN";
import LoginIcon from "@mui/icons-material/Login";
import PasswordIcon from "@mui/icons-material/Password";
import KeyIcon from "@mui/icons-material/Key";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import TaskIcon from "@mui/icons-material/Task";

import passReset from "../images/desc/login.png";
import loginPassReset from "../images/desc/loginPassReset.png";
import confirmPass from "../images/desc/confirmPass.png";
import passChangeIcon from "../images/desc/passChangeIcon.png";
import passChange from "../images/desc/passChange.png";
import addAccountIcon from "../images/desc/addAccountIcon.png";
import registerAccount from "../images/desc/registerAccount.png";
import editAccount from "../images/desc/editAccount.png";
import lockAccount from "../images/desc/lockAccount.png";
import lockedAccount from "../images/desc/lockedAccount.png";
import unlockAccount from "../images/desc/unlockAccount.png";
import lockedAccountInfo from "../images/desc/lockedAccountInfo.png";
import searchAccount from "../images/desc/searchAccount.png";
import NorthIcon from "@mui/icons-material/North";
import addPerformerIcon from "../images/desc/addPerformerIcon.png";
import descriptionPerformer from "../images/desc/descriptionPerformer.png";
import permissionPerformer from "../images/desc/permissionPerformer.png";
import permPerformer from "../images/desc/permPerformer.png";
import performers from "../images/desc/performers.png";
import addTask from "../images/desc/addTask.png";
import taskReturn from "../images/desc/taskReturn.png";
import taskRealization from "../images/desc/taskRealization.png";
import registeredTask from "../images/desc/registeredTask.png";
import taskRegistered from "../images/desc/taskRegistered.png";
import taskRegistered1 from "../images/desc/taskRegistered1.png";
import taskPriceAccepted from "../images/desc/taskPriceAccepted.png";
import taskAccepted from "../images/desc/taskAccepted.png";
import historyTask1 from "../images/desc/historyTask1.png";
import locationTask from "../images/desc/locationTask.png";
import filesEmpty from "../images/desc/filesEmpty.png";
import files1 from "../images/desc/files1.png";
import filesShare from "../images/desc/filesShare.png";
import settlements from "../images/desc/settlements.png";
import settlements1 from "../images/desc/settlements1.png";
import settlementTask from "../images/desc/settlementTask.png";
import taskOwnerAdd from "../images/desc/taskOwnerAdd.png";
import choosePerformer from "../images/desc/choosePerformer.png";
import choosePerformer1 from "../images/desc/choosePerformer1.png";

export default function AppDescription() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const style = {
    textDecoration: "none",
    color: "green",
  };
  const nbsp = "&nbsp;&nbsp;&nbsp;";
  const styleImg = { width: "100%", height: "auto" };
  const styleDiv = { maxWidth: "800px", marginLeft: "0", marginTop: "30px" };
  const styleButton = {
    marginTop: "5px",
    marginBottom: "5px",
    width: "350px",
    color: "green",
    justifyContent: "left",
    gap: "30px",
  };
  const styleIcon = {
    color: "green",
  };
  const up = (
    <>
      <a href="#start" style={style}>
        <Button variant="outlined">
          <NorthIcon style={styleIcon} />
        </Button>
      </a>
    </>
  );

  return (
    <div style={{ scrollBehavior: "smooth" }}>
      <VN userData={userData} />
      {userData && (userData.permId === "1" || userData.permId === "3") && (
        <Container className="page-content">
          <Row>
            <Col>
              <section id="start">
                <h5 style={style}>Opis działania aplikacji</h5>
              </section>
              <p className="p7">
                <Button style={styleButton} href="#logowanie">
                  <LoginIcon />
                  Logowanie
                </Button>
                <br />

                <Button style={styleButton} href="#zmiana-hasla">
                  <PasswordIcon /> Zmiana hasła
                </Button>
                <br />
                <Button style={styleButton} href="#uprawnienia">
                  <KeyIcon />
                  Grupy uprawnień
                </Button>
                <br />
                <Button style={styleButton} href="#rejestracja-osoby">
                  <AppRegistrationIcon />
                  Rejestracja osoby uprawnionej
                </Button>
                <br />
                <Button style={styleButton} href="#rejestracja-wykonawcy">
                  <AppRegistrationIcon />
                  Rejestracja Wykonawcy
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaRejestracja">
                  <TaskIcon />
                  Zlecenia - rejestracja
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaPrzydzial">
                  <TaskIcon />
                  Zlecenia - przydzielenie do Wykonawcy
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaHistoria">
                  <TaskIcon />
                  Zlecenia - historia
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaPliki">
                  <TaskIcon />
                  Zlecenia - pliki
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaKorespondencja">
                  <TaskIcon />
                  Zlecenia - korespondencja
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaRozliczenia">
                  <TaskIcon />
                  Zlecenia - rozliczenia
                </Button>
                <br />
                <Button style={styleButton} href="#zleceniaLokalizacja">
                  <TaskIcon />
                  Zlecenia - lokalizacja
                </Button>
              </p>
            </Col>
          </Row>
          <hr />
          <section id="logowanie">
            <h5>{up} Logowanie</h5>
            Poprzez logowanie rozumie się podanie prawidłowej nazwy użytkownika
            oraz hasła.
            <br />
            Do Systemu mogą zalogować się jedynie uprawnione osoby i wskazani
            przez nich Wykonawcy zleceń.
            <br />W przypadku zapomnienia hasła ze strony głównej jest możliwość
            jego ustawienia poprzez umieszczony link:
            <div style={styleDiv}>
              <img src={passReset} alt="reset hasła" style={styleImg} />
            </div>
            Jeżeli email użytkownika Systemu znajduje się w bazie danych,
            wówczas jest możliwość resetu hasła:
            <div style={styleDiv}>
              <img src={loginPassReset} alt="reset hasła" style={styleImg} />
            </div>
            Uwaga! Hasło musi składać się z co najmniej 8 znaków i zawierać min.
            1 cyfrę i jeden znak specjalny. Po wpisaniu hasła na wskazany adres
            email zostaje wysłany link z potwierdzeniem, który zawiera link do
            aktywacji nowego hasła:
            <div style={styleDiv}>
              <img src={confirmPass} alt="reset hasła" style={styleImg} />
            </div>
          </section>
          <hr />
          <section id="zmiana-hasla">
            <h5>{up}Zmiana hasła</h5>
            Po poprawnym zalogowaniu do Systemu jest możliwa również zmiana
            hasła po wybraniu opcji zmiany hasła jak na poniższym obrazku:
            <div style={styleDiv}>
              <img src={passChangeIcon} alt="reset hasła" style={styleImg} />
            </div>
            Aby zmienić istniejące hasło konieczne jest wypełnienie trzech pól:
            <br /> - dotychczasowe hasło,
            <br /> - nowe hasło,
            <br /> - powtórz nowe hasło
            <hr />
            <div style={styleDiv}>
              <img src={passChange} alt="reset hasła" style={styleImg} />
            </div>
          </section>
          <section id="uprawnienia">
            <h5>{up}Grupy uprawnień</h5>
            W Systemie znajdują się trzy grupy uprawnień:
            <br />
            <br />- Administrator
            <br /> - Rejestracja zleceń
            <br /> - Wykonawca
            <br />
            <br /> Uprawnienia Administratora zezwalają na:
            <br />- rejestrację i edycję kont osób uprawnionych do Systemu;
            <br />- rejestrację i edycję kont Wykonawców
            <br />- rejestrację i przeglądanie Zleceń
            <br />- dodawanie plików
            <br />- przydzielenie uprawnień
            <br />- dostęp do raportów
            <br />
            <br /> Uprawnienia rejestracji Zleceń zezwalają na:
            <br />- rejestrację i częściową edycję Zleceń wraz z ich zamknięciem
            <br />
            <br /> Uprawnienia Wykonawcy pozwalają na: - zmianę statusów
            Zlecenia (Przyjęcie Zlecenia, Realizacja, Zgłoszenie zakończenia
            prac)
            <br /> - dodawanie plików (Opracowanie wyjaśniające itp.)
            <hr />
          </section>
          <section id="rejestracja-osoby">
            <h5>{up}Rejestracja osoby uprawnionej</h5>
            <br />
            Aby dodać osobę uprawnioną do Systemu należy mieć uprawnienia
            Administratora.
            <br />
            Pod linkiem "Osoby uprawnione" należy użyć przycisku "Dodaj Osobę
            Rzeczoznawcy"
            <div style={styleDiv}>
              <img src={addAccountIcon} alt="dodaj konto" style={styleImg} />
            </div>
            <br /> Każdy użytkownik systemu posiada unikalne konto, z którym
            może się logować.
            <br />W celu utworzenia konta należy wypełnić pola:
            <br /> - konto logowania
            <br /> - imię i nazwisko soby uprawnionej
            <br /> - email
            <br /> - telefon
            <br /> - termin ważności konta
            <br />
            <div style={styleDiv}>
              <img src={registerAccount} alt="dodaj konto" style={styleImg} />
            </div>
            <br /> Po zarejestrowaniu konta i podaniu prawidłowego maila
            uprawniona osoba może samodzielnie ustawić swoje hasło w Systemie.
            <br /> Hasło logowania i uprawnienia (Rejestracja Zlecenia lub
            Administrator) może być również nadane z poziomu edycji osoby
            uprawnionej:
            <div style={styleDiv}>
              <img src={editAccount} alt="edytuj konto" style={styleImg} />
            </div>
            <br /> Gdy użytkownik w danej chwili nie może być dopuszczony do
            korzystania z Systemu jest możliwość jego zablkokowania poprzez
            przycisk "Zablokuj"
            <div style={styleDiv}>
              <img src={lockAccount} alt="blokuj konto" style={styleImg} />
            </div>
            <br /> Po zablokowaniu konta użytkownik będzie widoczny na liście
            uprawnionych jako zablokowany:
            <div style={styleDiv}>
              <img
                src={lockedAccount}
                alt="zablokowane konto"
                style={styleImg}
              />
            </div>
            <br /> Podczas próby logowania użytkownik wówczas zobaczy komunikat:
            <div style={styleDiv}>
              <img
                src={lockedAccountInfo}
                alt="zablokowane konto"
                style={styleImg}
              />
            </div>
            <br /> W celu jego ponownego odblokowania należy przywrócić jego
            dostęp z poziomu edycji osoby uprawnionej:
            <div style={styleDiv}>
              <img src={unlockAccount} alt="odblokuj konto" style={styleImg} />
            </div>
            <br /> W celu znalezienia osoby wg dowolnych kryteriów wprowadzonych
            do Systemu została wprowadzona wyszukiwarka:
            <div style={styleDiv}>
              <img src={searchAccount} alt="wyszukaj konto" style={styleImg} />
            </div>
          </section>
          <hr />
          <section id="rejestracja-wykonawcy">
            <h5>{up}Rejestracja konta Wykonawcy</h5>
            <br /> W celu rejestracji konta Wykonawcy - analogicznie jak w
            przypadku osoby uprawnionej w zakładce "Wykonawcy" należy kliknąć
            przycisk "Dodaj Wykonawcę"
            <div style={styleDiv}>
              <img src={addPerformerIcon} alt="dodaj konto" style={styleImg} />
            </div>
            <br />
            Należy wypełnić wskazane pola:
            <br /> - konto logowania
            <br /> - imię i nazwisko Wykonawcy
            <br /> - email
            <br /> - telefon
            <br /> - datę ważności konta
            <br />
            <br /> Po wprowadzeniu podstawowych danych Wykonawcy należy
            uzupełnić jego kwalifikacje, względem których będzie możliwe jego
            łatwe wyszukanie w liście Wykonawców, czyli pola: "Uprawnienia
            budowlane" i "Rzeczoznawstwo":
            <div style={styleDiv}>
              <img
                src={descriptionPerformer}
                alt="dodaj konto"
                style={styleImg}
              />
            </div>
            <br /> Kolejnymi danymi określającymi Wykonawcę są uprawnienia i
            deklaracje budowlane.
            <br /> W celu ich uzupełnienia wystarczy wybrać odpowiednią pozycję,
            która zostanie zapisana dla Wykonawcy
            <div style={styleDiv}>
              <img
                src={permissionPerformer}
                alt="dodaj uprawnienia"
                style={styleImg}
              />
            </div>
            <br /> Analogicznie jak w przypadku osób uprawnionych można z
            poziomu edycji Wykonawcy ustalić jego hasło. Wykonawca po
            zarejestrowaniu konta może poprzez główną stronę: https://pzitbrz.pl
            również ustalić hasło samodzielnie. Z pozycji edycji konta możliwe
            jest jego czasowe zablokowanie.
            <br /> Po zarejestrowaniu konta Wykonawca pojawi się na liście
            Wykonawców, gdzie możliwe jest jego wyszukanie wg:
            <br /> - danych personalnych
            <br /> - telefonu
            <br /> - uprawnień budowlanych
            <br /> - rzeczoznawstwa
            <div style={styleDiv}>
              <img src={performers} alt="Wykonawcy" style={styleImg} />
            </div>
            <br /> Na powyższej liście znajduje się informacja "Lb. zleceń br."
            mówiąca o ilości przyznanych zleceń w bieżącym roku kalendarzowym.
            <br /> W celu wyszukania Wykonawcy deklarującego uprawnienia
            budowlane należy przejść do zakładki "Znajdź wykonawców wg
            uprawnień" i zaznaczyć wg kryteriów, które są istotne dla Zlecenia.
            <div style={styleDiv}>
              <img
                src={permPerformer}
                alt="dodaj uprawnienia"
                style={styleImg}
              />
            </div>
            <br /> Podczas zaznaczania kolejnych pozycji lista wykonawców będzie
            się skracać do tych, którzy spełniają wszystkie zaznaczone kryteria.
          </section>
          <hr />
          <section id="zleceniaRejestracja">
            <h5>{up}Zlecenia - rejestracja</h5>
            <br /> Zlecenie może rejestrować Administrator lub wskazana przez
            niego osoba z odpowiednimi uprawnieniami "Rejestracja Zleceń".
            <br />W celu utworzenia nowego zlecenia należy użyć przycisku
            "Rejestracja zlecenia", w którym należy wypełnić niezbędne pola:
            <br /> - źródło zlecenia (poczta tradycyjna, mail, telefon)
            <br /> - czego dotyczy zlecenie
            <br /> - lokalizacja obiektu (gdzie ma być wykonane zlecenie)
            <br /> - kto jest Zleceniodawcą
            <br /> - adres mailowy Zleceniodawcy
            <br /> - telefon Zleceniodawcy
            <br /> - treść zlecenia (może to być treść przekopiowana z maila lub
            informacja, że znajduje się w załączonym pliku)
            <br /> - data rejestracji Zlecenia
            <br /> - termin realizacji Zlecenia
            <div style={styleDiv}>
              <img src={addTask} alt="dodaj zlecenie" style={styleImg} />
            </div>
            <br /> Po zarejestrowaniu Zlecenie pojawi sią na liście zleceń, jako
            "Zarejestrowane", a zgłoszenia przeterminowane będą oznaczone
            wykrzyknikiem.
            <div style={styleDiv}>
              <img src={registeredTask} alt="dodaj zlecenie" style={styleImg} />
            </div>
            <br />
            Podczas edycji Zlecenia widocznych jest 6 zakładek:
            <br /> - Treść Zlecenia
            <br /> - Historia
            <br /> - Pliki
            <br /> - Korespondencja (... w przygotowaniu)
            <br /> - Rozliczenia
            <br /> - Lokalizacja
          </section>
          <hr />
          <section id="zleceniaPrzydzial">
            <h5>{up}Zlecenia - przydzielenie do Wykonawcy</h5>W celu
            przydzielenia Zlecenia do Wykonawcy należy wybrać zlecenie ze
            statusem "Zarejestrowane" i w kolumnie "Wykonawca" nacisnąć ikonkę.
            <div style={styleDiv}>
              <img
                src={choosePerformer}
                alt="dodaj Wykonawcę"
                style={styleImg}
              />
            </div>
            Wówczas ukaże się lista z Wykonawcami i możliwością wybrania.
            Dodatkowo pokaże się wyszukiwarka, w której w celu ułatwienia można
            wpisać interesujące kryteria wyszkiwania, znajdujące się w
            polach"Upr. budowlane" i "Rzeczoznawstwo". W kolumnie "Lb. zleceń
            br." jest widoczna liczba już przyznanych zleceń w bieżącym roku
            kalendarzowym.
            <div style={styleDiv}>
              <img
                src={choosePerformer1}
                alt="dodaj Wykonawcę"
                style={styleImg}
              />
            </div>
            Po wybraniu Wykonawcy i naciśnięciu "Przydziel Zlecenie" otrzymamy
            komunikat potwierdzający
            <div style={styleDiv}>
              <img src={taskOwnerAdd} alt="dodaj Wykonawcę" style={styleImg} />
            </div>
            Potencjalny Wykonawca Zlecenia otrzyma powiadomienie mailowe:
            <div style={styleDiv}>
              <img
                src={taskRegistered}
                alt="dodaj Wykonawcę"
                style={styleImg}
              />
            </div>
            Po otrzymaniu powiadomienia Wykonawca powinien zalogować się do
            Systemu i zobaczy na swojej liście przydzielone zlecenie:
            <div style={styleDiv}>
              <img
                src={taskRegistered1}
                alt="Przydzielone Zlecenie"
                style={styleImg}
              />
            </div>
            W edycji Zlecenia na tym etapie można je wycofać poprzez naciśnięcie
            linku "Wycofaj Zlecenie" lub uzgodnić z Administratorem wycenę.
            <div style={styleDiv}>
              <img src={taskReturn} alt="Wycofaj Zlecenie" style={styleImg} />
            </div>
            W przypadku wycofania Zlecenia trafia ono na listę Administratora ze
            statusem "Zarejestrowane". Administrator wówczas może przydzielić
            Zlecenie innemu Wykonawcy. Gdy zgłoszenie nie zostanie wycofane, to
            Administrator oczekuje na wycenę Zlecenia ze strony Wykonawcy. Po
            uzgodnieniu wyceny należy ją wpisać do zakładki "Rozliczenia" (
            <i>Zlecenia - rozliczenia</i>). Nastąpi wówczas zmiana statusu na
            "Akceptacja wyceny":
            <div style={styleDiv}>
              <img
                src={taskPriceAccepted}
                alt="Wycena zaakceptowana"
                style={styleImg}
              />
            </div>
            Wykonawca po akceptacji wyceny może podjąć się jego realizacji
            poprzez naciśnięcie przycisku "Akceptacja Zlecenia i terminu
            wykonania":
            <div style={styleDiv}>
              <img
                src={taskAccepted}
                alt="Zlecenie zaakceptowane"
                style={styleImg}
              />
            </div>
            Po zaakceptowaniu zlecenia jego status zostanie automatycznie
            zmieniony w "Realizacja zadania"
            <div style={styleDiv}>
              <img
                src={taskRealization}
                alt="Zlecenie zaakceptowane"
                style={styleImg}
              />
            </div>
          </section>
          <hr />
          <section id="zleceniaHistoria">
            <h5 id="zleceniaHistoria">{up}Zlecenia - historia</h5>
            <br /> W Historii można zobaczyć status zlecenia jako
            "Zarejestrowane":
            <div style={styleDiv}>
              <img src={historyTask1} alt="historia" style={styleImg} />
            </div>
            <br /> W tym miejscu będą widoczne wszystkie zmiany dokonywane
            podczas realizacji Zlecenia (zmiana statusu, dodanie plików itd.)
          </section>
          <hr />
          <section id="zleceniaPliki">
            <h5>{up}Zlecenia - pliki</h5>
            <br /> Zarówno podczas rejestracji Zlecenia jak i w tej zakładce
            jest możliwe dodawanie plików dotyczących Zlecenia. Wprowadzone są
            ograniczenia systemowe, by plik nie przekraczał 2 MB.
            <br /> Plik można dodać poprzez przeciągnięcie w wyznaczone miejsce
            lub poprzez wybranie z dysku:
            <div style={styleDiv}>
              <img src={filesEmpty} alt="pliki" style={styleImg} />
            </div>
            <br /> Po poprawnym załadowaniu pliku na serwer powinien się ukazać
            komunikat potwierdzający:
            <div style={styleDiv}>
              <img src={files1} alt="pliki" style={styleImg} />
            </div>
            <br /> Plik może zostać udostępniony Wykonawcy poprzez wybranie
            odpowiedniej wartości w "Udostępnienie pliku" i powinien być opisany
            w celu jego wyszukiwania
            <div style={styleDiv}>
              <img src={filesShare} alt="pliki" style={styleImg} />
            </div>
          </section>
          <hr />
          <section id="zleceniaKorespondencja">
            <h5>{up}Zlecenia - korespondencja</h5>
          </section>
          <hr />
          <section id="zleceniaRozliczenia">
            <h5>{up}Zlecenia - rozliczenia</h5>
            <br /> Zakładka "Rozliczenia" służy dodaniu kwoty netto ustalonej z
            Wykonawcą powiększoną o podatek VAT i dodaniu marży PZITB.
            <div style={styleDiv}>
              <img src={settlements} alt="rozliczenia" style={styleImg} />
            </div>
            <br />
            Dane do rozliczenia wpisujemy klikając w przycisk "Aktualizuj
            wycenę":
            <div style={styleDiv}>
              <img src={settlements1} alt="rozliczenia" style={styleImg} />
            </div>
            <br /> Po zakończonym Zleceniu, zaksięgowaniu środków przez PZITB od
            Zleceniodawcy Wykonawca ma możliwość podziału kwoty do wartości
            wyceny pomiędzy poszczególnych podwykonawców.
            <div style={styleDiv}>
              <img src={settlementTask} alt="rozliczenia" style={styleImg} />
            </div>
          </section>
          <hr />
          <section id="zleceniaLokalizacja">
            <h5>{up}Zlecenia - lokalizacja</h5>
            <br />W zakładce "Lokalizacja" jest widoczna mapa z przybliżonym
            miejscem wskazanym w edycji Zlecenia jako lokalizacja obiektu.
            <div style={styleDiv}>
              <img src={locationTask} alt="historia" style={styleImg} />
            </div>
          </section>
          <hr />
        </Container>
      )}
    </div>
  );
}
